<template>
  <RevDrawer
    :name="MODAL_NAMES.EXPRESS_REPLACEMENT"
    :title="i18n(translations.title)"
  >
    <template #body>
      <RevIllustration
        alt=""
        class="rounded-lg mb-24 w-full"
        :height="180"
        src="/img/product/express-replacement/illustration.png"
        :width="327"
      />
      <section class="mt-24">
        <h2 class="heading-3 mb-12">
          {{ i18n(translations.section1Title) }}
        </h2>
        <div class="body-1">
          {{ i18n(translations.section1Text) }}
        </div>
      </section>
      <section class="mt-32">
        <h2 class="heading-3 mb-12">
          {{ i18n(translations.section2Title) }}
        </h2>
        <div class="bg-static-default-low rounded-md px-16 py-24">
          <div class="flex items-start">
            <div class="bg-static-default-mid rounded-full p-8">
              <IconTruckExpress />
            </div>
            <div class="ml-20">
              <h3 class="body-1-bold">
                {{ i18n(translations.section2Item2Title) }}
              </h3>
            </div>
          </div>
          <div class="mt-24 flex items-start">
            <div class="bg-static-default-mid rounded-full p-8">
              <IconPackage />
            </div>
            <div class="ml-20">
              <h3 class="body-1-bold">
                {{ i18n(translations.section2Item3Title) }}
              </h3>
            </div>
          </div>
        </div>
      </section>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { IconPackage } from '@ds/icons/IconPackage'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import { MODAL_NAMES } from '~/scopes/product/constants'

import translations from './ExpressReplacementModal.translations'

const i18n = useI18n()
</script>
